import type { RegScope } from "@/utils/types/flavor";

export const REG_SCOPES: RegScope[] = [
  { id: "fda",   label: "US — FDA GRAS", subtitle: "Generally Recognized as Safe · 2,148", checked: true },
  { id: "mfds",  label: "KR — MFDS",     subtitle: "Food Additive Code · 1,894" },
  { id: "efsa",  label: "EU — EFSA",     subtitle: "Flavouring substances · 2,540" },
  { id: "mhlw",  label: "JP — MHLW",     subtitle: "Designated additives · 828" },
  { id: "fsanz", label: "AU/NZ — FSANZ", subtitle: "Food Standards Code · 1,204" },
];
